import { useEffect } from 'react';

export function useSiteSealInitializer() {
  const isDevEnviroment = [
    'dev.ice.game',
    'localhost:3000',
    'gli.ice.game',
  ].includes(
    process.env.NEXT_PUBLIC_DEPLOY_URL.replace('https://', '').replace(
      'http://',
      '',
    ),
  );

  function handleInitializeSiteSeal() {
    if (typeof window == 'undefined' || isDevEnviroment) {
      return;
    }

    window?.anj_0b147e9d_859a_4c2c_9222_fb80d6fe8b8f?.init?.();
  }

  useEffect(handleInitializeSiteSeal, [isDevEnviroment]);
}
